import { TextDirectionType } from '@dh-io-emh/config-types';
import { infuse } from '../ioc-config';

// Composable to obtain the direction for the specific locale
export const useDirection = (): TextDirectionType => {
  const { textDirection, locale } = infuse('config');
  // For seamless markets dir should already be present on AEM template get it and use it if not on configs
  const pageDir = document.querySelector('html')?.getAttribute('dir') as TextDirectionType | undefined | null;
  const dir = textDirection?.[locale] ?? pageDir ?? 'ltr';

  return dir;
};
